import { Component } from 'react'

export class FilterBarTop extends Component {

	render() {
		return (
			<div className="pf-filter-bar-top">
				<div className="pf-tablet pf-tablet--flex">
					<div className="pf-filter-bar-top__text">
						<strong>Filter by</strong>
					</div>

					<div className="pf-filter-bar-top__reset">
						<button className="pf-filter-bar-top__reset-btn" onClick={this.props.resetFilters}>
							Reset<span className="sr-only"> filters</span>
						</button>
					</div>
				</div>

				<div className="pf-mobile">
					<div className="pf-filter-bar-top__mobile-results">
						{this.props.programsCount} Results
					</div>

					<div className="pf-filter-bar-top__filter-btn" onClick={this.props.toggleMobileFilterBar}>
						Filter
						<span>+</span>
					</div>
				</div>
			</div>
		)
	}

}